import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/magcards',
  component: Management,
  redirect: '/magcards/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/magcards/List'),
      meta: {
        auth: Auth.listMagcards
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/magcards/ListTable'),
          meta: {
            auth: Auth.listMagcards,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/magcards/New'),
      meta: {
        auth: Auth.createMagcard
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/magcards/Edit'),
      meta: {
        auth: Auth.updateMagcard
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/magcards/DetailLayout'),
      meta: {
        auth: Auth.showMagcard
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/magcards/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showMagcard
          }
        },
        // 刷卡记录
        {
          path: 'magcard_swipe_records',
          component: () => import('@/views/magcards/details/MagcardSwipeRecords'),
          meta: {
            tabName: 'magcard_swipe_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listMagcardSwipeRecords
          }
        },
        // 订单
        {
          path: 'orders',
          component: () => import('@/views/magcards/details/Orders'),
          meta: {
            tabName: 'orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrders
          }
        }
      ]
    }
  ]
}
